import PropTypes from 'prop-types'
import React from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import config from 'config'
import Bodymovin from 'components/bodymovin/bodymovin'

import styles from './dots_loading.scss'

const dotsAnimation = `${config.www_cdn}assets/media/animations/dots_loading.json`

const DotsLoading = props => (
	<Bodymovin
		path={dotsAnimation}
		loop={true}>
		<div styleName={classNames({
			wrapper: true,
			[`wrapper--theme-${props.theme}`]: true,
		})}>
		</div>
	</Bodymovin>
)

DotsLoading.propTypes = {
	theme: PropTypes.string,
}

DotsLoading.defaultProps = {
	theme: 'white',
}

export default CSSModules(DotsLoading, styles, {allowMultiple: true})
